import { Button, Modal } from "antd";
import React, { useState } from "react";
import { ISeatDetail } from "../../../../models/trip";
import { removeSeatApi } from "../../../../apis/seat.api";
import { ErrorPopup } from "../../../../utilities/swal";
import { message } from "antd";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonRemoveSeatProps {
  selectedSeats: ISeatDetail[];
  onSuccess: (value: ISeatDetail[]) => void;
}

const ButtonRemoveSeat: React.FC<ButtonRemoveSeatProps> = ({
  selectedSeats,
  onSuccess,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => {
    if (loading) return;
    setIsModalOpen(false);
  };
  useModalLockScroll(isModalOpen);
  const handleDeleteSeats = async () => {
    if (!selectedSeats?.length) return;

    try {
      setLoading(true);

      const payload = {
        tripId: selectedSeats[0]?.tripId,
        seatIds: selectedSeats.map((s) => s._id),
      };

      const rs = await removeSeatApi(payload);

      if (rs?.success) {
        message.success("Xóa ghế thành công");

        // callback về parent
        onSuccess(rs?.data || []);

        // đóng modal
        setIsModalOpen(false);
      } else {
        ErrorPopup("Hủy vé thất bại", rs?.message || "");
      }
    } catch (error: any) {
      ErrorPopup("Hủy vé thất bại", error?.message || "");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button
      size="large"
        danger
        onClick={showModal}
        className="font-medium"
        disabled={!selectedSeats?.length}
      >
        Xóa ghế
      </Button>

      <Modal
        title="Xác nhận xóa ghế"
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={handleDeleteSeats}
        okText="Xóa"
        cancelText="Hủy"
        okButtonProps={{ danger: true, loading }}
        cancelButtonProps={{ disabled: loading }}
      >
        <p>
          Bạn có chắc chắn muốn xóa các ghế:{" "}
          <b>{selectedSeats?.map((s) => s.seatCode).join(", ")}</b> không?
        </p>
      </Modal>
    </div>
  );
};

export default ButtonRemoveSeat;
